/* eslint-disable react/prop-types */
import { useState } from 'react';
import EditIcon from '../../../../assets/svg/Edit.svg';
import AssessmentConfigCreateModal from '../../Modal/GameConfigModal/AssessmentCreateModal';

export const assessmentConfigColumn = [
  {
    Header: ' ',
    columns: [
      {
        Header: 'Id',
        accessor: '_id',
      },

      {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ row }) => {
          return (
            <>
              <div>{row.values.type}</div>
            </>
          );
        },
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: ({ row }) => {
          const [isModal, setIsModal] = useState(false);

          const onToggleModal = () => {
            setIsModal(!isModal);
          };

          return (
            <div className="">
              <img
                id={row.values._id}
                src={EditIcon}
                alt=""
                onClick={() => onToggleModal()}
                className="w-8 p-1 hover:bg-[#dadbe6] bg-[#F4F5FF] rounded-full cursor-pointer"
              />
              {isModal && (
                <AssessmentConfigCreateModal
                  isModalOpen={isModal}
                  onToggleModal={onToggleModal}
                  id={row.original._id}
                  actionType="UPDATE"
                />
              )}
            </div>
          );
        },
      },
    ],
  },
];
